import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgGoToIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M48.937 12.8H38.4V9.6h10.537a3.2 3.2 0 0 1 2.263.937l2.262 2.263c.6.6.938 1.414.938 2.263V25.6h-3.2V15.063L29.93 36.33l-2.263-2.263zM9.6 22.4A6.4 6.4 0 0 1 16 16h12.8v3.2H16a3.2 3.2 0 0 0-3.2 3.2V48a3.2 3.2 0 0 0 3.2 3.2h25.6a3.2 3.2 0 0 0 3.2-3.2V35.2H48V48a6.4 6.4 0 0 1-6.4 6.4H16A6.4 6.4 0 0 1 9.6 48z"
    />
  </svg>
)
export default SvgGoToIcon
